import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Hook to get student certificates
 */
export const useGetStudentTrophies = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [trophies, setTrophies] = useState([]);

  const { axiosInstance } = useAxios();

  const getStudentTrophies = async ({ studentId }) => {
    const sId = Number(studentId);
console.log("sid is ", sId);
    if (!Number.isInteger(sId)) {
      setError("studentId and questId are required and must be integers");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/${sId}/trophies`
      );

      setTrophies(response?.data.data || []);

      console.log(setTrophies)
      return response?.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { getStudentTrophies, trophies, loading, error };
};